<template>
  <div class="vendor-allocated-table">
    <vue-good-table
      ref="table"
      :columns="columns"
      :rows="orders"
      :sort-options="{
        enabled: true,
        initialSortBy: {field: 'allocatedId', type: 'desc'}
      }"
      :search-options="{
        enabled: true,
        trigger: 'enter',
        skipDiacritics: true,
        placeholder: 'Search this table',
      }"
      :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPage: 10,
      }"
      @on-row-click="onRowClick"
    />

    <vue-modality
      ref="poNumModal"
      @ok="updatePO"
      @cancel="$refs.poNumModal.hide()"
      :title="modal.title"
      centered
    >
      <form method="post" accept-charset="UTF-8" action="">
        <label for="po_number" class="block text-sm font-medium leading-5 text-gray-700">PO Number</label>
        <input
          type="text"
          class="form-input block w-full sm:text-sm sm:leading-5"
          name="po_number"
          v-model="selectedPO"
          required
        />
        <label for="poDate" class="block text-sm font-medium leading-5 text-gray-700">PO Date for Delivery</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <input 
            type="date"
            class="form-input block w-full sm:text-sm sm:leading-5"
            value-type="YYYY-MM-DD"
            format="MM/DD/YYYY"
            v-model="selectedPoDate"
            name="poDate"
          /></div>
        <label for="anticipatedDD" class="block text-sm font-medium leading-5 text-gray-700">Estimated Date for Delivery</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <input 
            type="date"
            class="form-input block w-full sm:text-sm sm:leading-5"
            value-type="YYYY-MM-DD"
            format="MM/DD/YYYY"
            v-model="anticipatedDD"
            name="anticipatedDD"
            disabled 
          />
        </div>
      </form>
    </vue-modality>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import VueModality from 'vue-modality';

export default {
  name: 'Vendor-PO-Needed',
  props: {
    orders: Array
  },
  components: {
    VueGoodTable,
    VueModality
  },
  data() {
    return {
      modal: {
        title: '',
        allocatedId: '',
        orderId: ''
      },
      selectedPO: '',
      selectedPoDate: '',
      anticipatedDD: '',
      columns: [
        {
          label: 'Order ID',
          field: 'reference',
          type: "number",
          thClass: 'min-width-150',
        },
        {
          label: 'Allocated Order ID',
          field: 'allocatedId',
          type: "number",
          filterOptions: {
            enabled: true,
            placeholder: 'Filter',
          }
        },
        {
          label: 'Allocation Status',
          field: 'status',
        },
        {
          label: 'Account Name',
          field: 'accountName',
        },
        {
          label: 'RD Name',
          field: 'rd',
        },
        {
          label: 'Product Type',
          field: 'campaignName',
        },
        {
          label: 'Date',
          field: 'date',
        },
        {
          label: 'Action Needed?',
          field: this.ordersBtn,
          html: true
        },
      ]
    }
  },
  methods: {
    onRowClick (params) {
      const order = params.row;

      this.modal.title = `Add PO Number for Allocated Order: ${order.allocatedId}`;
      this.anticipatedDD = order.anticipatedDD;
      this.modal.allocatedId = order.allocatedId;
      this.modal.orderId = order.id;

      this.$refs.poNumModal.open();
    },
    ordersBtn () {
      return '<button class="rounded-full flex items-center text-base text-white shadow-solid bg-green py-2 px-4">Add PO</button>'
    },
    updatePO () {
      const data = {
        poNumber: this.selectedPO,
        poDate: this.selectedPoDate,
        orderId: this.modal.orderId,
      }

      axios.post(`/allocation/po/${this.modal.allocatedId}`, data).then((res) => {
        this.$refs.poNumModal.hide();
        location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
    }
  }
}
</script>